import { Link } from '@lokalise/louis';
import { Fragment } from 'react';

import classes from './Breadcrums.module.css';

type Item = {
    name: string;
    link: string;
};

type BreadcrumbsProps = {
    items: Item[];
};

const Breadcrums = ({ items }: BreadcrumbsProps) => {
    return (
        <nav aria-label="breadcrumb" className={classes.breadcrumbs} role="navigation">
            {items.map((item, index) => (
                <Fragment key={`${item.link}-${item.name}`}>
                    <Link className={classes.breadcrumbsItem} href={item.link} rel="noreferrer">
                        {item.name}
                    </Link>
                    {index < items.length - 1 && <span>{' — '}</span>}
                </Fragment>
            ))}
        </nav>
    );
};

export default Breadcrums;
